<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Formas de Pagamento" />
    <menuLateral />
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="container-fluid"></div>
        <!-- /.container-fluid -->
      </section>
      <!-- Main content -->
      <section class="content">

        <div class="card">
          <div class="card-header">
            <p class="card-title">Formas de pagamento padrão</p>
          </div>
          <div class="card-body" >
             <spinnerProcessando
              cssClass="ml-2"
              :status="flagsDeControle.carregandoDados.status"
              :mensagem="flagsDeControle.carregandoDados.mensagem"
            />
            <FormasPagamento
            v-show="!flagsDeControle.carregandoDados.status"
              :formasDePagamento="formasDePagamento"
              :habilitarSalvarFormaDePagamentoPadrao="true"
            />
            <CartaoPagamento
              v-show="!flagsDeControle.carregandoDados.status"
              :isLoading="isLoading"
              :isLoadingCartao="isLoadingCartao"
              :styleCartao="'col-md-3'"
              :bandeiraDoCartao="bandeiraDoCartao"
              :listaDeErros="listaDeErros"
              :obterBandeiraInputProp="obterBandeiraInput"
              :obterBandeiraProp="obterBandeira"
              :cartoes="cartoes"
              :flagsDeControle="flagsDeControle"
              @cadastrarCartao="cadastrarCartao"
              @definirCartaoPadrao="definirCartaoPadrao"
              @excluirCartao="excluirCartao"
              @selecionarCartao="selecionarCartao"
              @definirFormulario="definirFormulario"
              @determinarBandeiraDoCartao="determinarBandeiraDoCartao"
            />
          </div>
          <div class="col-12 px-3 pb-3" v-show="!flagsDeControle.carregandoDados.status">
            <div class="row">
              <div class="col-12 text-right" v-if="!estaCadastrandoCartao">
                <button @click="this.salvarInformacoes" class="botoes btn btn-primary btn-sm">Salvar</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import Pagamento from './js'
export default Pagamento
</script>
